var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.315,
    height: 43.687,
    viewBox: "0 0 36.315 43.687",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.842 -1006.65)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,1035.468l-18.158-9.513v14.869L24,1050.337q9.068-4.742,18.157-9.512v-14.869Z",
    fill: "rgba(85,10,188,0.86)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,1016.163,5.842,1006.65v14.869L24,1031.032q9.068-4.742,18.157-9.512v-14.869Z",
    fill: "rgba(85,10,188,0.86)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoDown);
export default __webpack_public_path__ + "static/media/goDown.8146389b218e4987e76c2af8c6c84701.svg";
export { ForwardRef as ReactComponent };